import { appStrings } from "utils/appStrings";
import AuthPane from "./AuthPane";
// import SidebarStat from "./SidebarStat";

const Sidebar: React.FC = () => {
  return (
    <div className="lg:h-full bg-white lg:mr-8 mt-8 lg:mt-0 dark:bg-gray-800">
      {/* Head */}
      <div className="py-12 w-2/3 mx-auto flex flex-wrap justify-end">
        <AuthPane />
      </div>
      {/* Description Ad */}
      <div className="py-6 w-2/3 mx-auto">
        <p className="font-semibold text-gray-900 dark:text-gray-100">
          {appStrings.descAdTitle}
        </p>
        <p className="mt-8 text-sm text-gray-900 text-justify leading-relaxed dark:text-gray-100">
          {appStrings.descAdDesc}
        </p>
      </div>
      {/* Widget Ad */}
      <div className="py-6 w-2/3 mx-auto">
        <p className="font-semibold text-gray-900 dark:text-gray-100">
          {appStrings.widgetAdTitle}
        </p>
        <p className="mt-8 text-sm text-gray-900 text-justify leading-relaxed dark:text-gray-100">
          {appStrings.widgetAdDesc}
        </p>
        <p className="text-left text-sm text-primary-600 mt-2">
          <a href={process.env.REACT_APP_WIDGET_URL}>
            {appStrings.showWidgets}
          </a>
        </p>
      </div>
      {/* Statistics */}
      {/* <div className="py-12 w-2/3 mx-auto">
        <p className="font-semibold text-gray-900 mb-8 dark:text-gray-100">
          {appStrings.stats}
        </p>
        <SidebarStat
          title={appStrings.totalQuizzes}
          color="green-500"
          value={17}
        />
        <SidebarStat
          title={appStrings.totalUsers}
          color="blue-500"
          value={163}
        />
        <SidebarStat
          title={appStrings.totalDoneQuizzes}
          color="indigo-500"
          value={390}
        />
        <SidebarStat
          title={appStrings.totalProblems}
          color="red-500"
          value={1211}
        />
      </div> */}
    </div>
  );
};

export default Sidebar;
